import React, { Component } from "react";
import { Link } from "react-router-dom";
import { modules } from "src/helpers/constants";
class Sidebar extends Component {
  render() {
    const { data } = this.props;
    return (
      <div className="detail-info">
        <div className="content-info">
          <div className="themesflat-headings style-2 clearfix">
            <h2 className="heading line-height-62">O GRADU</h2>
            <div className="sep has-width w80 accent-bg clearfix"></div>
          </div>
          <ul className="list-info has-icon icon-left">
            <li>
              <span
                className="text"
                style={{
                  paddingLeft: "0px",
                  textTransform: "uppercase",
                  color: "gray",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Osnovni podaci
              </span>
            </li>
            <li>
              <span className="text">
                Grad
                <span className="icon">
                  <i className="fa fa-building"></i>
                </span>
              </span>
              <span className="right">{data.partnerName}</span>
            </li>
            <li>
              <span className="text">
                Država
                <span className="icon">
                  <i className="fa fa-flag" />
                </span>
              </span>
              <span className="right">{data.country}</span>
            </li>
          </ul>
          <ul className="list-info has-icon ">
            <li>
              <span
                className="text"
                style={{
                  paddingLeft: "0px",
                  textTransform: "uppercase",
                  color: "gray",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Moduli
              </span>
            </li>
            {modules.map((module) =>
              data.modules?.includes(module) ? (
                <li key={module}>
                  <div>
                    <i
                      className="fa fa-check"
                      style={{ color: "green", width: "25px" }}
                    />
                    <span className="right">{module}</span>
                  </div>
                </li>
              ) : (
                <li key={module}>
                  <div>
                    <i
                      className="fa fa-minus"
                      style={{ color: "red", width: "25px" }}
                    />
                    <span className="right">{module}</span>
                  </div>
                </li>
              )
            )}

            {/* <li>
              <span
                className="text"
                style={{
                  paddingLeft: "0px",
                  textTransform: "uppercase",
                  color: "gray",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Prošireni moduli
              </span>
            </li>
            <li>
              <div>
                <i
                  className="fa fa-minus"
                  style={{ color: "red", width: "25px" }}
                />
                <span className="right">Transparentnost</span>
              </div>
            </li> */}
          </ul>
        </div>
      </div>
    );
  }
}

export default Sidebar;
